import script from "./TatamiHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TatamiHeader.vue?vue&type=script&setup=true&lang=js"

import "./TatamiHeader.vue?vue&type=style&index=0&id=78d0ab64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d0ab64"]])

export default __exports__